import axios from "axios";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
// import "./Users.css"
import Pagination from "../../../components/Pagination/Pagination";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BlockchainContext } from "../../../Context/BlockchainContext";

const AdminFormsList = ({ handleOpenForm }) => {
  const [certificates, setCertificates] = useState([]);
  const [studentModal, setStudentModal] = useState(false);
  const [openAddCourseModal, setAddCourseModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [addCourseData, setAddCourseData] = useState(null);
  const { user, getBalanceTestnet, mintCertificateMainFunction } =
    useContext(BlockchainContext);

  const mintCertificate = async () => {
    getBalanceTestnet();
    //! api data here, data which contain's uri
    // mintCertificateMainFunction(data)
    console.log("click");
  };

  useEffect(() => {
    const data = async () => {
      await axios
        .get(`https://backend.studyswiftly.com/api/v1/forms`)
        .then((res) => {
          setCertificates(res.data.result);
        });
    };
    data();
  }, []);

  //for pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [show, setShow] = useState(10);
  const [users, setUsers] = useState([]);
  const [lastPage, setLastPage] = useState(0);
  const [sliceUsers, setSliceUsers] = useState([]);

  // console.log(sliceProducts)

  useEffect(() => {
    const lastPage = Math.ceil(certificates?.length / show);
    setLastPage(lastPage);
  }, [certificates, show]);

  useEffect(() => {
    if (pageNumber) {
      const page = parseInt(pageNumber);
      const getSlicingProduct = certificates.slice(
        (page - 1) * show,
        page * show
      );
      setSliceUsers([...getSlicingProduct]);
      setPageNumber(parseInt(page));
    } else {
      const getSlicingProduct = certificates.slice(0, show);
      setSliceUsers([...getSlicingProduct]);
    }
  }, [certificates, show, pageNumber]);

  const pageHandle = (jump) => {
    // navigate(`/admin/products/${jump}`);
    setPageNumber(parseInt(jump));
  };

  const handleDelete = (id) => {
    Swal.fire({
      text: "Are you sure, you want to delete this Form?",
      showDenyButton: true,
      showCancelButton: false,
      customClass: "modal_class_success",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://backend.studyswiftly.com/api/v1/forms/${id}`)
          .then((res) => {
            if (res.status === 200) {
              const wrapper = document.createElement("div");
              wrapper.innerHTML = `<p class='text-break text-white'>Form deleted successfully.</p>`;

              Swal.fire({
                html: wrapper,
                icon: "success",
                customClass: "modal_class_success",
              });

              setCertificates(certificates.filter((ct) => ct._id !== id));
            }
          })
          .catch((error) => {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = `<p class='text-break text-white'>${error.response.data.message}</p>`;

            Swal.fire({
              html: wrapper,
              icon: "success",
              customClass: "modal_class_success",
            });
          });
      }
    });
  };
  const navigate = useNavigate();

  console.log(sliceUsers);
  console.log("sliceUsers");

  return (
    // <div className='adminBody' style={{ height: "100vh" }}>
    <div className="adminBody">
      {/* <p className='cursor-pointer' style={{ cursor: "pointer" }} title='Back' onClick={() => navigate(-1)}><ArrowBack /></p> */}
      <div className="d-flex justify-content-between align-items-center w-full">
        <h5 className="text-white text-start text-uppercase">Forms</h5>
        <Button onClick={handleOpenForm} variant="contained" className="my-4">
          Add Form
        </Button>
      </div>
      <h5 className="text-white text-start"></h5>
      <div className="adminCard py-2">
        <div className="tableNormal pt-5">
          <Table className="text-white adminDataTable">
            <thead>
              <tr>
                <th className="text-start ">Name</th>
                <th className="text-start adminHidden">Form Url</th>
                <th className="text-start">Details</th>

                <th className="text-start">Action</th>
              </tr>
            </thead>
            <tbody>
              {sliceUsers?.map((data) => (
                <tr className="tableRow" key={data._id}>
                  <td align="text-start">{data?.name}</td>
                  <td className="text-start adminHidden">{data?.url}</td>
                  <td className="text-start">{data?.description}</td>

                  <td className="action">
                    <div className="d-flex">
                      <Link to={`/admin/forms/${data?._id}`}>
                        <button className="editBtn">
                          <i className="fas fa-edit"></i>
                        </button>
                      </Link>
                      <button
                        onClick={() => handleDelete(data?._id)}
                        className="ms-1 studentBtnDlt"
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {sliceUsers?.length ? (
            <div>
              <Pagination
                lastPage={lastPage}
                page={pageNumber}
                pageHandle={pageHandle}
              />
            </div>
          ): (
            <p className="text-white text-center">Form is empty</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminFormsList;
